import React, { useState } from "react"
import { settings } from "./settings"
import Split from "react-split"
import { searchToObject } from "./helpers"
import { routes } from "./routes.js"

// GlobalState
import GlobalState from './context/globalState';

// Router
import { BrowserRouter, Route, Routes, matchPath } from 'react-router-dom';

// Components
import Header from './components/Header';
import Map from './components/Map';
import Search from './components/Search';
import Details from './components/Details';

// Styling
import './assets/sass/App.scss';

// React Google Analytics Module
import ReactGA from 'react-ga';


ReactGA.initialize(settings.googleAnalytics);

const validTypes = ['sales', 'people', 'persons', 'places', 'sources'];

const matchSearch = matchPath('/search/:q', window.location.pathname);

let matchRecordUrl = matchPath('/:type/:id/:title', window.location.pathname);
if (matchRecordUrl && !validTypes.includes(matchRecordUrl.params.type)) {
  matchRecordUrl = null;
}
if (!matchRecordUrl) {
  matchRecordUrl = matchPath('/:type/:urn', window.location.pathname);
  if (matchRecordUrl && !validTypes.includes(matchRecordUrl.params.type)) {
    matchRecordUrl = null;
  }
}

if (matchRecordUrl && matchRecordUrl.params.type === 'person') {
  matchRecordUrl = { ...matchRecordUrl, params: { ...matchRecordUrl.params, type: 'people' } };
}

const queryStrings = searchToObject()


/**
 * Custom slider icon between map and content
 */
const customGutter = (index, direction) => {
  const gutter = document.createElement('div')
  gutter.className = `gutter gutter-${direction} test`

  const sliderIcon = document.createElement('div')
  sliderIcon.className = `slider`
  gutter.appendChild(sliderIcon)

  const leftArrow = document.createElement('div')
  leftArrow.className = 'left-arrow'
  sliderIcon.appendChild(leftArrow)

  const rightArrow = document.createElement('div')
  rightArrow.className = 'right-arrow'
  sliderIcon.appendChild(rightArrow)

  return gutter
}

function App() {

  const [splitSizes, setSplitSizes] = useState(null);

  const onDragEnd = (sizes) => {
    console.log('split sizes:')
    console.log(sizes)
    setSplitSizes(sizes)
  }

  const showMaintenance = true
  console.log("🚀 ~ App ~ showMaintenance:", showMaintenance)

  const styles = { 
    textAlign: 'center', 
    fontSize: '2rem' 
  };

  const backgroundStyles = {
    backgroundImage: "url('" + process.env.REACT_APP_URL + "assets/img/banner.jpg')",
  }

  return (
    <GlobalState>
      <BrowserRouter basename={process.env.REACT_APP_PATH}>
      {showMaintenance ? (
        <>
          <div id="header">
            <div className="bg" style={backgroundStyles}>
              <a className="headerLink" href="/" title="Navigate to the homepage">The art world in Britain 1660 to 1735</a>
            </div>
          </div>

          <div className="columns content-columns is-mobile">
          <div className="column" style={styles}>
            <br />
            <h1>
              The art world in Britain 1660–1735 database is currently under
              construction.<br />We will return soon.
            </h1>
          </div>
        </div>
        </>
      ) : (
        <>
          <Header />

          <div className="columns is-gapless h-100 content-columns is-mobile">

            <div className="column">

              <Split
                className="split"
                direction="horizontal"
                onDragEnd={onDragEnd}
                sizes={[50, 50]}
                minSize={100}
                gutter={customGutter}
              >
                <Map splitSizes={splitSizes} />

                <div className="split-content column-content">
                  <div className="content-column">
                    <Routes>
                      {routes.flatMap((route, i) => {
                        const paths = Array.isArray(route.path)
                          ? route.path
                          : (route.path ? [route.path] : ['*']);
                        const C = route.component;
                        return paths.map((path, j) => (
                          <Route key={`${i}-${j}`} path={path} element={<C />} />
                        ));
                      })}
                    </Routes>
                  </div>
                </div>

              </Split>

            </div>

            <div className="column search-column is-hidden-touch is-one-third">
              <div className="column-content">
                <div className="content">
                  <Search queryStrings={queryStrings} matchSearch={matchSearch} source="app" />
                </div>
              </div>
            </div>

          </div>

          <Details matchRecordUrl={matchRecordUrl} />
          </>
        )}

      </BrowserRouter>
    </GlobalState>
  );
}

export default App;
